import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServicePartner {
    lookupService = new APIServiceLookUp();

    async checkLink(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}partner/checkLink`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}